import { MainLayout } from '../Layouts/MainLayout.tsx';
import { MenuItemsUsuario } from '../Menu/MenuItemsUsuario.tsx';

export function Perfil() {
    return (
        <MainLayout
            menuItems={MenuItemsUsuario}
            titulo={'Perfil'}
        ></MainLayout>
    );
}
